/* ─── ButtonGroup ─── */

.root {
  display: inline-flex;
  align-items: center;
}

.root[data-orientation="vertical"] {
  flex-direction: column;
}

/* ─── Horizontal: collapse border-radius between siblings ─── */

.root[data-orientation="horizontal"] > *:not(:first-child):not(:last-child) {
  border-radius: 0;
}

.root[data-orientation="horizontal"] > *:first-child:not(:last-child) {
  border-start-end-radius: 0;
  border-end-end-radius: 0;
}

.root[data-orientation="horizontal"] > *:last-child:not(:first-child) {
  border-start-start-radius: 0;
  border-end-start-radius: 0;
}

/* Collapse adjacent borders (outlined variant) */
.root[data-orientation="horizontal"] > * + * {
  margin-inline-start: -1px;
}

/* ─── Vertical: collapse border-radius between siblings ─── */

.root[data-orientation="vertical"] > *:not(:first-child):not(:last-child) {
  border-radius: 0;
}

.root[data-orientation="vertical"] > *:first-child:not(:last-child) {
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}

.root[data-orientation="vertical"] > *:last-child:not(:first-child) {
  border-start-start-radius: 0;
  border-start-end-radius: 0;
}

.root[data-orientation="vertical"] > * + * {
  margin-block-start: -1px;
}

/* ─── Ensure focused button stacks above neighbors ─── */

.root > *:focus-visible {
  z-index: 1;
}
